import React, { Component } from "react";
import { /* MuiThemeProvider, */ withStyles } from "@material-ui/core/styles";

import {
  Alert,
  Paper,
  Typography,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button as MTButton,
  Autocomplete,
  TextField,
  /* DialogActions, */
} from "@mui/material";

import ApiService, { Status, showToast } from "../../../ApiService";
import { forwardRef } from "react";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";

import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

/* import EditIcon from "@material-ui/icons/Edit"; */
import GridContainer from "../../../components/Custom/Grid/GridContainer";
import GridItem from "../../../components/Custom/Grid/GridItem";

import ObjectUtil from "../../../util/objectUtil";
import MaterialTable from "../../../components/MaterialTable";
import { /* subMonths, subDays, */ format } from "date-fns";
import { Grid } from "@material-ui/core";

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },

  detailhead: {
    fontSize: 12,
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    marginLeft: 20,
    minWidth: 120,
    maxWidth: 300,
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
});

class PayoutManageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethods: [],

      merchants: [],
      selectedMerchant: null,

      payouts: [],
      selectedPayout: null,

      failed: false,
      success: false,
      loading: false,

      showPayoutDetailsDialog: false,
      showActionDialog: false,
      action: null,
      label: null,
      msg: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onMerchantChange = this.onMerchantChange.bind(this);
  }

  componentDidMount() {
    this.fetchAllMerchants();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  fetchAllMerchants() {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  }

  // onMerchantChange(event, newValue) {
  //   if (newValue) {
  //     this.setState({
  //       selectedMerchant: newValue.id,
  //       label: newValue.merchantName + "-" + newValue.code,
  //     });
  //     this.fetchPayoutPaymentMethods();
  //     this.fetchPayoutsManage();
  //   } else {
  //     this.setState({
  //       selectedMerchant: null,
  //       label: null,
  //     });
  //   }
  // }

  onMerchantChange = (event, newValue) => {
    this.setState(
      {
        selectedMerchant: newValue ? newValue.id : null,
      },
      () => {
        this.fetchPayoutPaymentMethods();
        this.fetchPayoutsManage();
      }
    );
  };
  fetchPayoutPaymentMethods() {
    if (this.state.selectedMerchant === null) {
      this.setState({ msg: true });
    } else {
      ApiService.fetchPayoutPaymentMethods({
        merchantId: this.state.selectedMerchant,
      }).then((res) => {
        if (res != null) {
          this.setState({ paymentMethods: res.data, msg: false });
        }
      });
    }
  }

  fetchPayoutsManage() {
    if (this.state.selectedMerchant === null) {
      this.setState({ msg: true });
    } else {
      ApiService.fetchPayoutsManage({
        merchantId: this.state.selectedMerchant,
      }).then((res) => {
        if (res != null) {
          if (res.data) {
            res.data.map((r) => {
              let paymentItem = null;
              this.state.paymentMethods.map((p) => {
                if (paymentItem == null && p.id === r.paymentMethodId) {
                  paymentItem = p;
                }
              });
              if (paymentItem == null) r.paymentMethod = r.paymentMethodId;
              else {
                r.paymentMethod =
                  paymentItem.methodType === "IBAN"
                    ? `(${paymentItem.methodType}) - ${paymentItem.iban} ${paymentItem.ibanSortCode}`
                    : paymentItem.methodType === "IFSC"
                    ? `(${paymentItem.methodType}) - ${paymentItem.accountName} ${paymentItem.accountNo}`
                    : paymentItem.methodType === "UPI"
                    ? `(${paymentItem.methodType}) - ${paymentItem.upiId}`
                    : r.paymentMethodId;
              }
            });
            this.setState({ payouts: res.data, msg: false });
          }
        }
      });
    }
  }

  onClickShowPayoutDetails() {
    this.setState({ showPayoutDetailsDialog: true });
  }

  showConfirmation(showAction, action) {
    console.log("showConfirmation -> showAction, action: ", showAction, action);
    this.setState({
      showActionDialog: showAction,
      action: action,
    });
  }

  performAction() {
    const action = this.state.action;
    const payout = this.state.selectedPayout;
    if (action !== null && payout !== null) {
      const reqObj = {
        id: payout.id,
        merchantId: payout.merchantId,
      };
      console.log("PerformAction -> Action, ReqObj: ", action, reqObj);
      if (action === "APPROVE") this.approvePayout(reqObj);
      else if (action === "REJECT") this.rejectPayout(reqObj);
      else if (action === "SETTLE") this.settlePayout(reqObj);
    }
  }

  approvePayout(payout) {
    ApiService.approvePayout(payout).then((res) => {
      this.showResponseToast(res, "approved");
      this.setState({
        showActionDialog: false,
        action: null,
      });
    });
  }

  rejectPayout(payout) {
    ApiService.rejectPayout(payout).then((res) => {
      this.showResponseToast(res, "rejected");
      this.setState({
        showActionDialog: false,
        action: null,
      });
    });
  }

  settlePayout(payout) {
    ApiService.settlePayout(payout).then((res) => {
      this.showResponseToast(res, "settled");
      this.setState({
        showActionDialog: false,
        action: null,
      });
    });
  }

  showResponseToast(res, action) {
    console.log("showResponseToast", res, action);
    if (res.status === 200) {
      showToast({
        type: Status.SUCCESS,
        title: "Status",
        description: `Payout ${action} successfully.`,
      });
      this.setState({ showPayoutDetailsDialog: false }, () =>
        this.fetchPayoutsManage()
      );
    } else {
      showToast({
        type: Status.ERROR,
        title: "Status",
        description: res.data,
      });
    }
  }

  tableIcons = {
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  displayField(title, value) {
    return (
      <>
        <GridItem xs={6} sm={6} md={5} lg={4}>
          <Typography noWrap variant="caption">
            <strong>{title}</strong>
          </Typography>
        </GridItem>
        <GridItem xs={6} sm={6} md={7} lg={6}>
          <Typography variant="caption">{value}</Typography>
        </GridItem>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    const { merchants, selectedMerchant, payouts, selectedPayout, action } =
      this.state;
    return (
      <React.Fragment>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Payout Management
          </Typography>
          <Divider light className={classes.searchbar} />
          {this.state.failed && (
            <Alert severity="error" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation="0">
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.msg && (
            <Alert severity="error" elevation="0">
              Please select Merchant
            </Alert>
          )}
          &nbsp;
          <GridContainer>
            {/* <GridItem xs={8} sm={8} md={4} lg={3}>
              <FormControl
                className={classes.formControl}
                sx={{ minWidth: "250px" }}
              >
                <InputLabel id="merchantSelectLabel">Merchants</InputLabel>
                <Select
                  value={selectedMerchant}
                  MenuProps={this.MenuProps}
                  onChange={this.onMerchantChange}
                  name="selectedMerchant"
                  labelId="merchantSelectLabel"
                  id="merchantTerminalSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {merchants &&
                    ObjectUtil.SortArray(merchants, [
                      "merchantName",
                      "code",
                    ]).map((m) => (
                      <MenuItem key={m.id} value={m} dense>
                        {m.merchantName + "-" + m.code}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </GridItem> */}

            {/* <GridItem xs={8} sm={8} md={4} lg={3}>
              <FormControl
                className={classes.formControl}
                sx={{ minWidth: "250px" }}
              >
                <Autocomplete
                  value={this.state.label}
                  onChange={this.onMerchantChange}
                  id="merchantSelectLabel"
                  options={merchants}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.id}>
                        {option.merchantName + "-" + option.code}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Merchant"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </GridItem> */}

            <Grid item xs={8} sm={8} md={4} lg={3}>
              <FormControl
                className={classes.formControl}
                sx={{ minWidth: "250px", marginLeft: "15px" }}
              >
                <Autocomplete
                  value={
                    merchants.find((mt) => mt.id === selectedMerchant) || null
                  }
                  onChange={this.onMerchantChange}
                  options={merchants}
                  getOptionLabel={(option) =>
                    option ? option.merchantName + "-" + option.code : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      labelId="merchantSelectLabel"
                      label="Merchants"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </GridContainer>
          <MaterialTable
            style={{ margin: "1em 0 0 0" }}
            title="Merchant Payouts for Approval / Settlement"
            icons={this.tableIcons}
            columns={[
              { field: "id", title: "Payout Id" },
              { field: "amount", title: "Amount" },
              {
                field: "paymentMethod",
                title: "Payment Method",
              },
              {
                field: "created",
                title: "Created On",
                render: (rowData) => {
                  return (
                    <Typography noWrap variant="caption">
                      {format(new Date(rowData.created), "dd MMM yyyy")}
                    </Typography>
                  );
                },
              },
              { field: "status", title: "Status" },
              {
                field: "statusDate",
                title: "Status Date",
                render: (rowData) => {
                  return (
                    <Typography noWrap variant="caption">
                      {format(new Date(rowData.statusDate), "dd MMM yyyy")}
                    </Typography>
                  );
                },
              },
            ]}
            data={payouts}
            onSelectionChange={(event, rowSelected) => {
              console.log("onSelectionChange", event, rowSelected);
              this.setState({
                selectedPayout: event && event.length > 0 ? rowSelected : null,
              });
            }}
            actions={[
              {
                icon: (props) => (
                  <MTButton
                    variant="contained"
                    disabled={selectedPayout === null}
                    color="primary"
                    size="small"
                  >
                    {" "}
                    Details
                  </MTButton>
                ),
                tooltip: "Action",
                isFreeAction: false,
                onClick: (event) => this.onClickShowPayoutDetails(),
              },
            ]}
            options={{
              search: false,
              exportButton: false,
              pageSize: 15,
              pageSizeOptions: [15, 30, 45],
              padding: "dense",
              showEmptyDataSourceMessage: true,
              selection: true,
              emptyRowsWhenPaging: false,
            }}
          />
          {/* Payout Details Dialog */}
          <Dialog
            open={this.state.showPayoutDetailsDialog}
            onClose={() => this.setState({ showPayoutDetailsDialog: false })}
          >
            <DialogTitle
              id="customized-dialog-mapterminal"
              onClose={this.hideAddTerminal}
            >
              Payout Details
            </DialogTitle>
            <DialogContent>
              {selectedPayout !== null && (
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ display: "flex", justifyContent: "right" }}
                  >
                    {selectedPayout.status === "PAYOUT_PENDING" && (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CheckIcon />}
                        onClick={() => this.showConfirmation(true, "APPROVE")}
                        sx={{ margin: "2px" }}
                      >
                        {" "}
                        Approve
                      </MTButton>
                    )}
                    {selectedPayout.status === "PAYOUT_PENDING" && (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CloseIcon />}
                        onClick={() => this.showConfirmation(true, "REJECT")}
                        sx={{ margin: "2px" }}
                      >
                        {" "}
                        Reject
                      </MTButton>
                    )}
                    {selectedPayout.status === "PAYOUT_APPROVED" && (
                      <MTButton
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<DoneIcon />}
                        onClick={() => this.showConfirmation(true, "SETTLE")}
                        sx={{ margin: "2px" }}
                      >
                        {" "}
                        Settle
                      </MTButton>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}></GridItem>
                  {this.displayField("Amount", selectedPayout.amount)}
                  {this.displayField(
                    "Payment Method",
                    selectedPayout.paymentMethod
                  )}
                  {this.displayField(
                    "created",
                    format(new Date(selectedPayout.created), "dd MMM yyyy")
                  )}
                  {this.displayField("Status", selectedPayout.status)}
                  {this.displayField(
                    "Status Date",
                    format(new Date(selectedPayout.statusDate), "dd MMM yyyy")
                  )}
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginTop: "20px" }}
                  >
                    <Typography noWrap variant="subtitle2">
                      <strong>Wire Details</strong>
                    </Typography>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Wire id </TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Currency</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedPayout.payoutWires.map((w, key) => {
                          return (
                            <TableRow key={key}>
                              <TableCell>{w.wireId} </TableCell>
                              <TableCell>{w.payoutAmount}</TableCell>
                              <TableCell>{w.currency}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </GridItem>
                </GridContainer>
              )}
            </DialogContent>
          </Dialog>
          {/* Action Confirmation Dialog */}
          <Dialog
            open={this.state.showActionDialog}
            onClose={() => this.setState({ showActionDialog: false })}
          >
            <DialogTitle
              id="customized-dialog-mapterminal"
              onClose={() => this.setState({ showActionDialog: false })}
            >
              Confirm {action ? ObjectUtil.TitleCase(action) : ""}
            </DialogTitle>
            <DialogContent>
              <GridContainer>
                <GridItem xs={12} style={{ marginBottom: "20px" }}>
                  <Typography noWrap variant="subtitle1">
                    Do you wish to {action ? action.toLowerCase() : ""} this
                    payout?
                  </Typography>
                </GridItem>
                <GridItem xs={6}>
                  <MTButton
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => this.performAction()}
                    sx={{ float: "right", paddingRight: "5px" }}
                  >
                    {" "}
                    Submit
                  </MTButton>
                </GridItem>
                <GridItem xs={6}>
                  <MTButton
                    variant="outlined"
                    size="small"
                    onClick={() => this.setState({ showActionDialog: false })}
                  >
                    {" "}
                    Cancel
                  </MTButton>
                </GridItem>
              </GridContainer>
            </DialogContent>
          </Dialog>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(useStyles)(PayoutManageComponent);
